// Swiper
import './swiper.js';

// Alpine
import './alpine.js';

// Swiper
import { initSwipers } from './swiper.js';

// Element width CSS var
import { setTitleWidthOnWrappers } from './element-width.js';

setTitleWidthOnWrappers('.title-wrapper', '.dynamic-title');

// Init functions
document.addEventListener(
	'DOMContentLoaded',
	() => {
		initSwipers();
		setTitleWidthOnWrappers();
	},
	{ passive: true }
);

// Init resize functions
window.addEventListener(
	'resize',
	() => {
		setTitleWidthOnWrappers();
	},
	{ passive: true }
);